//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
import {Link} from 'react-router-dom'
//@end

//@import components
import NewsSkeleton from './newsSkeleton'
import AlertComponent from 'app_components/commons/alert/containers/alertComponent';
import NewsCardComponent from 'app_components/commons/newsCard'
//@end

// @import hooks
// @end

// @INFO Import types
// import {IFetchNew} from 'app_types/campus/news/newsTypes'
// @end

// @INFO Import services
import {routingService} from 'app_services/routingService'
// @end

// @INFO Import Styles
import './../newsModule.scss'

// @ADD Component types
interface INewsModuleLayoutProps {
  posts: Array<any>
  status: null | 'loading' | 'error'
}

const NewsModuleLayout: React.FC<INewsModuleLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <div className='news_campus-component' id="news_campus">
      {props.status === 'loading' ? (
        <NewsSkeleton />
      ) : (
        <>
          {props.posts && props.posts.length > 0 ? (
            <>
              <div className="title">
                {t('modules.news.contact_title')}
              </div>
              <div className="list-news">
                {props.posts.map((n) => (
                    <div className={`item `} key={n.key}>
                      <Link to={routingService.getPublicPath(`/noticia/${n.slug}`)}>
                        <NewsCardComponent {...n} />
                      </Link>
                    </div>
                  ))
                }
              </div>
            </>
          ) : (
            <div>
              <AlertComponent
                type='warning'
                title={t('modules.news.no_data')}
              />
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default NewsModuleLayout
